export default {
	// SET
	SET_DRAWER_STATE: (state, bool) => {
		state.drawerState = bool;
	},
};
